import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=38a4e824&scoped=true&"
import script from "./Area.vue?vue&type=script&lang=js&"
export * from "./Area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a4e824",
  null
  
)

component.options.__file = "Area.vue"
export default component.exports